// extracted by mini-css-extract-plugin
export default {"appHeader":"Header_appHeader__jlFes","loginBlock":"Header_loginBlock__hwXuy"};